import { loadLocalStorageState } from '../localStorage';

// BACKEND_URL может оканчиваться на '/', нормализуем, чтобы не получить '//oauth/...'.
export const normalizeBackendUrl = (backendUrl) => (backendUrl || '').replace(/\/+$/, '');

export const oauthLoginUrl = (backendUrl) =>
  `${normalizeBackendUrl(backendUrl)}/oauth/login/keycloak`;

// Небольшой попап фиксированного размера (как у SSO-провайдеров), по центру экрана.
const REAUTH_POPUP_WIDTH = 500;
const REAUTH_POPUP_HEIGHT = 600;
const reauthPopupFeatures = () => {
  const { availWidth, availHeight, availLeft = 0, availTop = 0 } = window.screen;
  const width = Math.min(REAUTH_POPUP_WIDTH, availWidth);
  const height = Math.min(REAUTH_POPUP_HEIGHT, availHeight);
  const left = Math.round(availLeft + (availWidth - width) / 2);
  const top = Math.round(availTop + (availHeight - height) / 2);
  return `width=${width},height=${height},left=${left},top=${top}`;
};

export const logoutUrl = (backendUrl) => `${normalizeBackendUrl(backendUrl)}/oauth/logout`;

// backendUrl для модулей без доступа к store (обработчик 401 в api/authFetch).
export const persistedBackendUrl = () => (loadLocalStorageState() || {}).backendUrl || '';

// Имя окна попапа и сообщение, которым перезагрузившееся в попапе приложение
// сигналит опенеру об успешном логине (см. index.js).
export const REAUTH_WINDOW_NAME = 'vizorlytics-reauth';
export const REAUTH_MESSAGE = 'vizorlytics-reauth-success';

// Открывает попап с OIDC-логином Keycloak. Резолвится, когда попап сообщил об успехе
// (postMessage из index.js) либо был закрыт пользователем — в обоих случаях запрос
// повторяется и сессия перепроверяется. Вызывать только из обработчика клика,
// иначе браузер заблокирует попап.
export const openReauthPopup = (backendUrl) =>
  new Promise((resolve, reject) => {
    const popup = window.open(oauthLoginUrl(backendUrl), REAUTH_WINDOW_NAME, reauthPopupFeatures());
    if (!popup) {
      reject(new Error('Popup blocked'));
      return;
    }

    let timer;
    let onMessage;

    const cleanup = () => {
      window.clearInterval(timer);
      window.removeEventListener('message', onMessage);
      if (!popup.closed) {
        popup.close();
      }
    };

    // resolve(true) — логин точно прошёл (попап вернулся на origin приложения и отчитался);
    // resolve(false) — попап просто закрыли, успех не подтверждён.
    onMessage = (event) => {
      if (event.origin === window.location.origin && event.data === REAUTH_MESSAGE) {
        cleanup();
        resolve(true);
      }
    };

    // Фолбэк: пользователь закрыл попап руками (или detection в попапе не сработал).
    timer = window.setInterval(() => {
      if (popup.closed) {
        cleanup();
        resolve(false);
      }
    }, 500);

    window.addEventListener('message', onMessage);
  });

export const redirectToLogout = (backendUrl) => {
  window.location.assign(logoutUrl(backendUrl));
};
